import $ from 'jquery';
import { isLG, addUniqueEventListener } from '../../util/domutils';
import initCarouselSwipability from '../../thirdParty/bootstrap/carouselSwipe';
import { EVENTS as GALLERY_EVENTS, GLOBALS as GLOBAL_PINCH } from './imageGallery';

const GLOBALS = {
  CAROUSELS: [],
};

const CLASSES = {
  CAROUSEL: 'carousel',
};

const SELECTORS = {
  CAROUSEL_CONTAINER: '.primary-images__carousel',
  QUICKVIEW_MODAL: '#quickViewModal',
};

const clearCarousel = (carouselElement) => {
  if (GLOBALS.CAROUSELS.length) {
    const currentCarousel = GLOBALS.CAROUSELS.find(carousel => carousel === carouselElement);
    const currentCarouselIndex = GLOBALS.CAROUSELS.findIndex(carousel => carousel === carouselElement);

    if (currentCarousel) {
      currentCarousel.classList.remove(CLASSES.CAROUSEL);
      $(currentCarousel).carousel('dispose');

      GLOBALS.CAROUSELS.splice(currentCarouselIndex, 1);
    }
  }
};

const disableCarousel = (carouselElement) => {
  carouselElement.dataset.swipeDisabled = 'true';
};

const enableCarousel = (carouselElement) => {
  carouselElement.dataset.swipeDisabled = 'false';
};

const initQuickviewCleanup = (carouselElement) => {
  const quickViewModal = document.querySelector(SELECTORS.QUICKVIEW_MODAL);

  if (quickViewModal) {
    $(quickViewModal).on('hidden.bs.modal', clearCarousel.bind(null, carouselElement));
  }
};

const initCarousel = (carouselElement) => {
  carouselElement.classList.add(CLASSES.CAROUSEL);

  GLOBALS.CAROUSELS.push($(carouselElement).carousel({ interval: false })[0]);

  addUniqueEventListener(document, 'product:beforeAttributeSelect', clearCarousel.bind(null, carouselElement));
  addUniqueEventListener(document, GALLERY_EVENTS.PINCH_ZOOM_START, disableCarousel.bind(null, carouselElement));
  addUniqueEventListener(document, GALLERY_EVENTS.PINCH_ZOOM_END, enableCarousel.bind(null, carouselElement));

  $(carouselElement).on('slid.bs.carousel', () => {
    GLOBAL_PINCH.PINCH_ZOOM.forEach((pinchZoomObj) => {
      pinchZoomObj.update({ type: 'resize' });
    });
  });
  initQuickviewCleanup(carouselElement);
};

export default (forceCarousel) => {
  const isProductSet = document.querySelector('.product-set-detail') !== null;
  const carousels = Array.from(document.querySelectorAll(SELECTORS.CAROUSEL_CONTAINER));

  carousels.forEach((carousel) => {
    if (!isLG() || forceCarousel || isProductSet) {
      initCarousel(carousel);
      initCarouselSwipability(carousel, {});
    } else {
      clearCarousel(carousel);
    }
  });
};
